import React, { useEffect, useMemo, useState } from "react";
import {
  Container,
  Row,
  Col,
  CardBody,
  Card,
  Button
} from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { toast, ToastContainer } from "react-toastify";
import moment from "moment";
import ReservationTable from "./ReservationTable";
import ReservationModals from "./ReservationModals";
import ReservationDetails from "./ReservationDetails";
import CreateReservationModal from "./CreateReservationModal";
import axios from "../../../utills/api"

const computeNights = (checkIn, checkOut) => {
  if (!checkIn || !checkOut) return 0;
  const start = new Date(checkIn);
  const end = new Date(checkOut);
  const msPerDay = 1000 * 60 * 60 * 24;
  return Math.max(0, Math.round((end - start) / msPerDay));
};

const API_URL = "bookings";
const API_MANAGE = "manage";
const API_KYC = "kyc";
const Reservation = () => {
  document.title = "HMS | Reservation";
  const [bookings, setBookings] = useState([]);
  const [isEditMode, setIsEditMode] = useState(false);
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [extendRequests, setExtendRequests] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [createModal, setCreateModal] = useState(false);
  const [reservationFilter, setReservationFilter] = useState("ALL");

  const [reservationModal, setReservationModal] =
    useState(false);

  const toggleReservationModal = () => {
    setReservationModal(!reservationModal);
  };

  const [reservationSource, setReservationSource] =
    useState("ALL");
  const [selectedBooking, setSelectedBooking] =
    useState(null);

  const [modal, setModal] =
    useState(false);

  const [deleteModal, setDeleteModal] =
    useState(false);

  const [extensionModal, setExtensionModal] =
    useState(false);

  const [kycModal, setKycModal] =
    useState(false);

  const [selectedKyc, setSelectedKyc] =
    useState(null);

  const [kycData, setKycData] =
    useState(null);

  const handleUploadKyc = (
    booking
  ) => {
    setSelectedBooking(booking);
    setKycModal(true);
  };

  const [formData, setFormData] =
    useState({
      bookingId: "",
      name: "",
      mobile: "",
      source: "",
      checkIn: "",
      checkOut: "",
      bookingDate: "",
      numberOfGuests: "",
      roomType: "",
      assignRoom: "",
      payment: "",
      statusPayment: "Paid",
      status: "Pending",
    });

  const [roomTypes, setRoomTypes] = useState([]);
  const [roomsList, setRoomsList] = useState([]);
  const [availableRooms, setAvailableRooms] = useState([]);
  const [activeFilter, setActiveFilter] = useState("ALL");
  const [reservationSearch, setReservationSearch] =
    useState("");

  const today = new Date().toISOString().split("T")[0];
  const todayCheckIn =
    bookings.filter(
      (b) =>
        b.checkIn?.split("T")[0] ===
        today
    ).length;
  const todayDeparture =
    bookings.filter(
      (b) =>
        b.checkOut?.split("T")[0] ===
        today
    ).length;

  const upcomingCheckIn =
    bookings.filter(
      (b) =>
        b.checkIn?.split("T")[0] > today
    ).length;

  const upcomingDeparture =
    bookings.filter(
      (b) =>
        b.checkOut?.split("T")[0] >
        today
    ).length;

  const [tableData, setTableData] =
    useState([]);

  // ==================================================
  // ALL YOUR API CALLS
  // ==================================================
  const fetchKyc = async (
    bookingId
  ) => {
    try {

      const res =
        await axios.get(
          `/kyc/${bookingId}`
        );

      console.log(
        "KYC RESPONSE",
        res.data
      );

      setSelectedKyc(
        res.data || null
      );

    } catch (err) {

      console.error(err);

      setSelectedKyc(null);

    }
  };

  const fetchBookings = async () => {
    try {
      const response = await axios.get(API_URL);
      const data = response.data || response;

      // ✅ Sort latest first
      const sorted = [...data].sort(
        (a, b) => new Date(b.bookingDate) - new Date(a.bookingDate)
      );

      setBookings(sorted);
    } catch (error) {
      console.error(error);
      toast.error("Failed to fetch bookings!");
    }
  };

  const refreshBookings = async (bookingId = null) => {
    try {
      const response = await axios.get(API_URL);
      const data = response.data || response;

      const sorted = [...data].sort(
        (a, b) => new Date(b.bookingDate) - new Date(a.bookingDate)
      );

      setBookings(sorted);

      if (bookingId) {
        const updatedBooking = sorted.find(
          (b) => b.bookingId === bookingId
        );

        if (updatedBooking) {
          setSelectedBooking(updatedBooking);
        }
      } else if (selectedBooking) {
        const updatedBooking = sorted.find(
          (b) => b.bookingId === selectedBooking.bookingId
        );

        if (updatedBooking) {
          setSelectedBooking(updatedBooking);
        }
      }
    } catch (err) {
      console.error(err);
      toast.error("Failed to refresh bookings");
    }
  };

  // Fetch room types & rooms
  // ✅ Replace your fetchRoomsData() with this
  const fetchRoomsData = async () => {
    try {
      // Fetch room types with tenant filter via auth
      const { data: roomTypesData } = await axios.get(`${API_MANAGE}/room-types`);
      setRoomTypes(Array.isArray(roomTypesData) ? roomTypesData : []);

      // Fetch rooms (populated with type + price)
      const { data: roomsData } = await axios.get(`${API_MANAGE}/add-rooms`);
      setRoomsList(Array.isArray(roomsData) ? roomsData : []);

    } catch (err) {
      console.error("❌ Error fetching room data:", err);
    }
  };

  const fetchExtendRequests = async (tenantIdParam) => {
    try {
      if (!tenantIdParam) {
        console.warn("⚠️ Tenant ID not provided, skipping extension requests fetch.");
        return;
      }

      const res = await axios.get(`/extension-requests/${tenantIdParam}`);
      setExtendRequests(res.data || []);
    } catch (err) {
      console.error("❌ Error fetching extension requests:", err);
    }
  };

  const fetchAvailability = async () => {

    try {

      const res = await axios.get(
        "/inventory/availability",
        {
          params: {
            roomTypeId: "6a153d5391e142545f943b1b",
            checkIn: "2026-05-27",
            checkOut: "2026-05-30",
          },
        }
      );

      console.log("✅ RESPONSE:", res.data);

    } catch (err) {

      console.log(err.response?.data);

    }
  };

  const generateInventory = async () => {

    try {

      const res = await axios.post(
        "/inventory/generate"
      );

      console.log(
        "✅ INVENTORY GENERATED",
        res.data
      );

    } catch (err) {

      console.log(err);
    }
  };

  const computeExtendedNights = (oldCheckOut, newCheckOut) => {
    if (!oldCheckOut || !newCheckOut) return 0;
    const oldDate = new Date(oldCheckOut);
    const newDate = new Date(newCheckOut);
    const msPerDay = 1000 * 60 * 60 * 24;
    return Math.max(0, Math.round((newDate - oldDate) / msPerDay));
  };

  // --- Handle Extension Modal Open ---
  const handleExtension = (req) => {
    const requestObj = extendRequests.find((r) => r._id === req._id) || req;
    setSelectedRequest({
      ...requestObj,
      requestedGuests: requestObj.requestedGuests || 1,
      oldCheckOut: requestObj.oldCheckOut,
      newCheckOut: requestObj.newCheckOut,
      assignedRoom: requestObj.assignedRoom || "",
      roomType: requestObj.roomType || "",
      paymentPerNight: requestObj.paymentPerNight || 0,
      guestName: requestObj.guestName || requestObj.name || "",
    });
    setExtensionModal(true);
  };

  // Approve extension request
  // Approve extension request
  const handleApproveExtension = async () => {
    if (!selectedRequest) return;

    try {
      // Compute additional nights and extension amount
      const extendedNights = computeExtendedNights(
        selectedRequest.oldCheckOut,
        selectedRequest.newCheckOut
      );
      const paymentPerNight = Number(selectedRequest.paymentPerNight) || 0;
      const extensionAmount = extendedNights * paymentPerNight;

      // Approve extension in backend
      await axios.put(
        `/extension-requests/${selectedRequest._id}/approve`,
        {
          assignedRoom: selectedRequest.assignedRoom,
          roomNumber: selectedRequest.assignedRoom,
          guestName: selectedRequest.guestName,
          roomType: selectedRequest.roomType,
          paymentPerNight,
          extendedNights,
          extraAmount: extensionAmount, // store separately
        }
      );

      // Update booking with new check-out only, do NOT touch payment
      const bookingToUpdate = bookings.find(
        (b) =>
          b._id === selectedRequest.bookingId ||
          b.bookingId === selectedRequest.bookingId
      );

      if (bookingToUpdate) {
        await axios.put(`${API_URL}/${bookingToUpdate._id}`, {
          checkOut: selectedRequest.newCheckOut,
          extensionAmount, // store separately
        });

        // Update local state for check-out and extension amount only
        setBookings((prev) =>
          prev.map((b) =>
            b._id === bookingToUpdate._id
              ? { ...b, checkOut: selectedRequest.newCheckOut, extensionAmount }
              : b
          )
        );
      }

      toast.success("Extension approved successfully!");
      setExtensionModal(false);
      fetchExtendRequests(); // refresh pending requests
      addNotification(
        `Extension approved for ${selectedRequest.guestName}, extended by ${computeExtendedNights(selectedRequest.oldCheckOut, selectedRequest.newCheckOut)} night(s)`,
        "info"
      );

    } catch (err) {
      console.error(err.response?.data || err.message);
      toast.error("Failed to approve extension request");
    }
  };

  const handleKycUploaded = (kyc) => {
    console.log("✅ Uploaded KYC:", kyc);

    setSelectedKyc(kyc);
  };

  // Merge extension requests into bookings
  const mergedBookings = bookings.map((b) => {
    const ext = extendRequests.find(
      (er) => er.bookingId === b._id || er.bookingId === b.bookingId
    );
    return {
      ...b,
      extensionRequest: ext // only keep the request for modal actions
    };
  });

  const filteredBookings = useMemo(() => {
    switch (activeFilter) {
      case "TODAY_CHECKIN":
        return mergedBookings.filter(
          (b) =>
            b.checkIn &&
            new Date(b.checkIn)
              .toISOString()
              .split("T")[0] === today
        );

      case "TODAY_CHECKOUT":
        return mergedBookings.filter(
          (b) =>
            b.checkOut &&
            new Date(b.checkOut)
              .toISOString()
              .split("T")[0] === today
        );

      case "UPCOMING_CHECKIN":
        return mergedBookings.filter(
          (b) =>
            b.checkIn &&
            new Date(b.checkIn)
              .toISOString()
              .split("T")[0] > today
        );

      case "UPCOMING_CHECKOUT":
        return mergedBookings.filter(
          (b) =>
            b.checkOut &&
            new Date(b.checkOut)
              .toISOString()
              .split("T")[0] > today
        );

      default:
        return mergedBookings;
    }
  }, [mergedBookings, activeFilter, today]);

 const filteredReservationBookings = useMemo(() => {
  const todayDate = moment().format("YYYY-MM-DD");

  return mergedBookings.filter((booking) => {
    const checkIn = moment(
      booking.checkIn
    ).format("YYYY-MM-DD");

    const checkOut = moment(
      booking.checkOut
    ).format("YYYY-MM-DD");

    // --------------------------
    // Reservation Filter
    // --------------------------

    let reservationMatch = true;

    switch (reservationFilter) {
      case "TODAY_CHECKIN":
        reservationMatch =
          checkIn === todayDate &&
          booking.status !== "Cancelled";
        break;

      case "TODAY_DEPARTURE":
        reservationMatch =
          checkOut === todayDate &&
          booking.status !== "Cancelled";
        break;

      case "UPCOMING_CHECKIN":
        reservationMatch =
          checkIn > todayDate &&
          booking.status !== "Cancelled";
        break;

      case "UPCOMING_DEPARTURE":
        reservationMatch =
          checkOut > todayDate &&
          booking.status !== "Cancelled";
        break;

      case "CANCELLED":
        reservationMatch =
          booking.status === "Cancelled";
        break;

      default:
        reservationMatch = true;
    }

    // --------------------------
    // OTA Filter
    // --------------------------

    const sourceMatch =
      reservationSource === "ALL" ||
      booking.channel === reservationSource;

    // --------------------------
    // Search Filter
    // --------------------------

    const searchText =
      reservationSearch?.toLowerCase() || "";

    const searchMatch =
      !searchText ||
      booking.bookingId
        ?.toLowerCase()
        .includes(searchText) ||
      booking.name
        ?.toLowerCase()
        .includes(searchText) ||
      booking.email
        ?.toLowerCase()
        .includes(searchText) ||
      booking.mobile
        ?.toLowerCase()
        .includes(searchText) ||
      booking.channel
        ?.toLowerCase()
        .includes(searchText);

    return (
      reservationMatch &&
      sourceMatch &&
      searchMatch
    );
  });
}, [
  mergedBookings,
  reservationFilter,
  reservationSource,
  reservationSearch,
]);

  const handleSaveBooking = async () => {
    try {
      const payload = {
        ...formData,
        roomTypeId: formData.roomType, // ✅ FIX KEY
        bookingDate: formData.bookingDate || new Date().toISOString(),
        payment: Number(formData.payment),
      };

      delete payload.roomType; // ✅ remove wrong field

      if (isEditMode) {
        await axios.put(`${API_URL}/${selectedBooking._id}`, payload);
      } else {
        await axios.post(API_URL, payload);
      }

      toast.success("Booking saved successfully!");
      fetchBookings();
      setModal(false);

    } catch (err) {
      console.error(err.response?.data || err.message);
      toast.error("Failed to save booking!");
    }
  };
  // Create & Edit modal handlers
  const handleCreate = () => {
    setIsEditMode(false);
    setSelectedBooking(null);
    setFormData({
      bookingId: "",
      name: "",
      mobile: "",
      source: "",
      checkIn: "",
      checkOut: "",
      bookingDate: new Date().toISOString().split("T")[0],
      numberOfGuests: "",
      roomType: "",
      assignRoom: "",
      payment: "",
      statusPayment: "Paid",
      status: "Pending",
    });
    setModal(true);
  };

  const handleEdit = (booking) => {
    setIsEditMode(true);
    setSelectedBooking(booking);
    const assignedRoom = roomsList.find((r) => r.roomNumber === booking.assignRoom);
    setFormData({
      bookingId: booking.bookingId,
      name: booking.name,
      mobile: booking.mobile,
      source: booking.source,
      checkIn: booking.checkIn?.split("T")[0] || "",
      checkOut: booking.checkOut?.split("T")[0] || "",
      bookingDate: booking.bookingDate?.split("T")[0] || "",
      numberOfGuests: booking.numberOfGuests,
      roomType: assignedRoom?.roomType?._id || "",
      assignRoom: booking.assignRoom || "",
      payment: booking.payment || "",
      statusPayment: booking.statusPayment || "Paid",
      status: booking.status || "Pending",
    });
    setModal(true);
  };

  // Delete Booking
  const handleDelete = async () => {
    try {
      if (selectedBooking) {
        await axios.delete(`${API_URL}/${selectedBooking._id}`);
        toast.success("Booking deleted successfully!");
        setDeleteModal(false);
        fetchBookings();
      }
    } catch (error) {
      toast.error("Failed to delete booking!");
      console.error(error);
    }
  };

  const handleViewKyc = async (booking) => {
    try {
      const res = await axios.get(`${API_KYC}/${booking._id}`);
      setKycData(res.data);
      setKycModal(true);
    } catch (err) {
      console.error(err);
      toast.error("No KYC data found for this booking.");
    }
  };

  const cancelledCount =
    bookings.filter(
      (b) =>
        b.status?.toLowerCase() ===
        "cancelled"
    ).length;

  // ==================================================
  // useEffects
  // ==================================================
  useEffect(() => {
    if (!selectedBooking?._id) {
      setSelectedKyc(null);
      return;
    }

    fetchKyc(
      selectedBooking._id
    );
  }, [selectedBooking]);

  useEffect(() => {
    if (!formData.roomType) {
      setAvailableRooms([]);
      setFormData((prev) => ({
        ...prev,
        assignRoom: "",
        payment: 0,
      }));
      return;
    }

    useEffect(() => {
      if (
        bookings.length > 0 &&
        !selectedBooking
      ) {
        setSelectedBooking(
          bookings[0]
        );
      }
    }, [bookings, selectedBooking]);

    const selectedRooms = roomsList.filter(
      (r) => r.roomType?._id === formData.roomType
    );

    let filtered = selectedRooms;

    const nights = computeNights(
      formData.checkIn,
      formData.checkOut
    );

    if (formData.checkIn && formData.checkOut) {
      const checkInDate = new Date(formData.checkIn);
      const checkOutDate = new Date(formData.checkOut);

      filtered = selectedRooms.filter((room) => {
        const overlappingBooking = bookings.find(
          (booking) => {
            if (
              isEditMode &&
              booking._id === selectedBooking?._id
            )
              return false;

            const roomNumber =
              booking.assignRoom ||
              booking.assignedRoom?.roomNumber;

            if (
              roomNumber !== room.roomNumber
            )
              return false;

            const existingCheckIn =
              new Date(booking.checkIn);

            const existingCheckOut =
              new Date(booking.checkOut);

            return (
              checkInDate <
              existingCheckOut &&
              checkOutDate >
              existingCheckIn
            );
          }
        );

        return !overlappingBooking;
      });

      setAvailableRooms(filtered);

      if (
        !filtered.find(
          (r) =>
            r.roomNumber ===
            formData.assignRoom
        )
      ) {
        setFormData((prev) => ({
          ...prev,
          assignRoom: "",
        }));
      }
    } else {
      setAvailableRooms(selectedRooms);
    }

    if (!isEditMode) {
      const selectedType =
        roomTypes.find(
          (t) =>
            t._id === formData.roomType
        );

      const price =
        selectedType
          ? Number(selectedType.price)
          : 0;

      setFormData((prev) => ({
        ...prev,
        payment:
          nights * price,
      }));
    }
  }, [
    formData.roomType,
    formData.checkIn,
    formData.checkOut,
    roomsList,
    bookings,
    roomTypes,
    isEditMode,
    selectedBooking,
  ]);

  useEffect(() => {
    setTableData(
      mergedBookings || []
    );
  }, [mergedBookings]);

  useEffect(() => {
    if (
      bookings.length &&
      !selectedBooking
    ) {
      setSelectedBooking(
        bookings[0]
      );
    }
  }, [
    bookings,
    selectedBooking,
  ]);

  useEffect(() => {
    setTableData(mergedBookings);

    if (
      mergedBookings.length > 0 &&
      !selectedBooking
    ) {
      setSelectedBooking(
        mergedBookings[0]
      );
    }
  }, [mergedBookings]);

  useEffect(() => {
    const loadData = async () => {
      try {
        await fetchRoomsData();

        const bookingRes = await axios.get(API_URL);
        const data = bookingRes.data || bookingRes;
        const sorted = [...data].sort((a, b) => new Date(b.bookingDate) - new Date(a.bookingDate));
        setBookings(sorted);

        // ✅ Extract tenantId dynamically from the first booking (if available)
        if (sorted.length > 0 && sorted[0].tenantId) {
          const tenantId = sorted[0].tenantId;
          console.log("🏨 Tenant ID from bookings:", tenantId);
          await fetchExtendRequests(tenantId);
        } else {
          console.warn("⚠️ No tenantId found in bookings.");
        }
      } catch (error) {
        console.error("❌ Error loading bookings:", error);
        toast.error("Failed to fetch bookings!");
      }
    };

    loadData();
  }, []);

  // Compute available rooms whenever room type or check-in/check-out changes
  useEffect(() => {
    if (!formData.roomType) {
      setAvailableRooms([]);
      setFormData((prev) => ({ ...prev, assignRoom: "", payment: 0 }));
      return;
    }

    let nights = computeNights(formData.checkIn, formData.checkOut);

    // Filter out rooms that are already booked
    if (formData.checkIn && formData.checkOut) {
      const checkInDate = new Date(formData.checkIn);
      const checkOutDate = new Date(formData.checkOut);
      setAvailableRooms(filtered);

      if (!filtered.find((r) => r.roomNumber === formData.assignRoom)) {
        setFormData((prev) => ({ ...prev, assignRoom: "" }));
      }
    } else {
      setAvailableRooms(selectedRooms);
    }

    // Update payment automatically based on room type price and nights
    // ONLY for new bookings, NOT for edit or extensions
    if (!isEditMode) {
      const selectedTypeObj = roomTypes.find((t) => t._id === formData.roomType);
      const pricePerNight = selectedTypeObj ? Number(selectedTypeObj.price) : 0;

      setFormData((prev) => ({
        ...prev,
        payment: nights * pricePerNight,
      }));
    }
  }, [
    formData.roomType,
    formData.checkIn,
    formData.checkOut,
    roomsList,
    bookings,
    isEditMode,
    selectedBooking,
    roomTypes,
  ]);


  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb
            title="Bookings"
            pageTitle="Reservation"
          />
          <Row>
            <Card>
              <CardBody>
                <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                  <div className="d-flex flex-wrap gap-2">
                    <Button
                      outline
                      color={
                        reservationFilter === "TODAY_CHECKIN"
                          ? "primary"
                          : "dark"
                      }
                      size="sm"
                      onClick={() =>
                        setReservationFilter("TODAY_CHECKIN")
                      }
                    >
                      Today Check-In
                      <span className="ms-1 badge bg-dark">
                        {todayCheckIn}
                      </span>
                    </Button>

                    <Button
                      outline
                      color={
                        reservationFilter === "TODAY_DEPARTURE"
                          ? "primary"
                          : "dark"
                      }
                      size="sm"
                      onClick={() =>
                        setReservationFilter("TODAY_DEPARTURE")
                      }
                    >
                      Today Departure
                      <span className="ms-1 badge bg-dark">
                        {todayDeparture}
                      </span>
                    </Button>
                    <Button
                      outline
                      color={
                        reservationFilter === "UPCOMING_CHECKIN"
                          ? "primary"
                          : "dark"
                      }
                      size="sm"
                      onClick={() =>
                        setReservationFilter("UPCOMING_CHECKIN")
                      }
                    >
                      Upcoming Check-In
                      <span className="ms-1 badge bg-dark">
                        {upcomingCheckIn}
                      </span>
                    </Button>

                    <Button
                      outline
                      color={
                        reservationFilter === "UPCOMING_DEPARTURE"
                          ? "primary"
                          : "dark"
                      }
                      size="sm"
                      onClick={() =>
                        setReservationFilter("UPCOMING_DEPARTURE")
                      }
                    >
                      Upcoming Departure
                      <span className="ms-1 badge bg-dark">
                        {upcomingDeparture}
                      </span>
                    </Button>

                    <Button
                      outline
                      color={
                        reservationFilter === "CANCELLED"
                          ? "danger"
                          : "dark"
                      }
                      size="sm"
                      onClick={() =>
                        setReservationFilter("CANCELLED")
                      }
                    >
                      Cancelled
                      <span className="ms-1 badge bg-dark">
                        {cancelledCount}
                      </span>
                    </Button>
                    <Button
                      color={
                        reservationFilter === "ALL"
                          ? "primary"
                          : "light"
                      }
                      size="sm"
                      onClick={() =>
                        setReservationFilter("ALL")
                      }
                    >
                      All Reservations
                    </Button>
                  </div>
                  <Button
                    color="primary"
                    size="sm"
                    onClick={toggleReservationModal}
                  >
                    Create Reservation
                  </Button>
                </div>
              </CardBody>
            </Card>
          </Row>
          <Row>
            {/* LEFT SECTION */}
            <ReservationTable
              bookings={bookings}
              mergedBookings={filteredReservationBookings}
              filteredBookings={filteredReservationBookings}
              selectedBooking={selectedBooking}
              cancelledCount={cancelledCount}
              setSelectedBooking={
                setSelectedBooking
              }
              reservationSearch={
                reservationSearch
              }
              setReservationSearch={
                setReservationSearch
              }
              today={today}
              todayCheckIn={todayCheckIn}
              todayDeparture={todayDeparture}
              upcomingCheckIn={
                upcomingCheckIn
              }
              upcomingDeparture={
                upcomingDeparture
              }
              handleCreate={
                handleCreate
              }
              reservationSource={reservationSource}
              setReservationSource={setReservationSource}
              selectedRows={selectedRows}
              setSelectedRows={setSelectedRows}
            />
            {/* RIGHT SECTION */}
            <Col md={4}>
              <ReservationDetails
                selectedBooking={
                  selectedBooking
                }
                selectedKyc={
                  selectedKyc
                }
                onUploadKyc={(booking) => {
                  setSelectedBooking(
                    booking
                  );
                  setKycModal(true);
                }}
                selectedKyc={selectedKyc}
                onUploadKyc={
                  handleUploadKyc
                }
                refreshBookings={refreshBookings}
              />
            </Col>
          </Row>
          {/* ALL MODALS */}
          <ReservationModals
            modal={modal}
            setModal={setModal}
            deleteModal={
              deleteModal
            }
            setDeleteModal={
              setDeleteModal
            }
            extensionModal={
              extensionModal
            }
            setExtensionModal={
              setExtensionModal
            }
            kycModal={
              kycModal
            }
            setKycModal={
              setKycModal
            }
            onKycUploaded={handleKycUploaded}
            formData={
              formData
            }
            setFormData={
              setFormData
            }
            selectedBooking={
              selectedBooking
            }
            selectedRequest={
              selectedRequest
            }
            setSelectedRequest={
              setSelectedRequest
            }
            roomTypes={
              roomTypes
            }
            roomsList={
              roomsList
            }
            availableRooms={
              availableRooms
            }
            kycData={
              kycData
            }
            isEditMode={
              isEditMode
            }
            handleSaveBooking={
              handleSaveBooking
            }
            handleDelete={
              handleDelete
            }
            handleApproveExtension={
              handleApproveExtension
            }
            computeNights={
              computeNights
            }
            computeExtendedNights={
              computeExtendedNights
            }
            kycModal={kycModal}
            setKycModal={
              setKycModal
            }
            selectedBooking={
              selectedBooking
            }
          />

          <CreateReservationModal
            isOpen={reservationModal}
            toggle={toggleReservationModal}
            onSuccess={() => {
              loadBookings(); // or fetchReservations(), whichever function refreshes your table
            }}
          />
        </Container>
        <ToastContainer />
      </div>
    </React.Fragment>
  );
};

export default Reservation;